import React, { Fragment, useState } from 'react';
import { Nav } from 'react-bootstrap';
import {
  ArrowLeftRight, ArrowsMove, BagCheck, BarChart, Cart, CartPlusFill, Check2Circle, ChevronDown, ClockHistory, Cpu, FilePerson,
  FilePlus,
  GearWideConnected,
  House, List, People,
  PeopleFill,
  Collection,
  // Key,
  // PersonBadge,
  PersonFill,
  PersonLinesFill, PersonPlusFill,
  Phone,
  PhoneLandscape,
  PhoneVibrate, Unlock, UnlockFill,
  Wallet2,
  WalletFill
} from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import MD5 from 'crypto-js/md5';

import { authorization } from '../authorization';
import NavItem from '../Model/navItemModel';
import {
  routeAddContact, routeAddPurchase, routeAddSensor, routeAirquino,
  routeChangeAccount, routeClawback, routeContacts, routeHome, routeLicenses,
  routeNftMove, routeOwners, routePurchases, routeSensors, routeTempSensors,
  transactions, routeLicensesHistory, routeAnalitics, routeGenerationBillingCodes,
  routeWalletsList, routeMergeAccount, routeB2B, routeSensorsTesting,
  awairRefundVoucherList
} from '../Routes/routes';

function menuIsEmpty(item: NavItem): boolean {
  const items = item.children || [];
  for (let i = 0; i < items.length; i += 1) {
    const subitem = items[i];
    const itemCheck = authorization.isAuthorized(subitem?.roles, subitem?.forRealm);
    if (itemCheck) {
      // console.log('menuIsEmpty false', item);
      return false;
    }
  }
  // console.log('menuIsEmpty true', item);
  return true;
}

// TODO: make generics... row passed as props!
const PwSidebarNoRouter = (props: any) => {
  const [menuContactOpen, setMenuContactOpen] = useState(false);
  const [menuSensorsOpen, setMenuSensorsOpen] = useState(false);
  const [menuWalletsOpen, setMenuWalletsOpen] = useState(false);
  const [menuLicenseOpen, setMenuLicenseOpen] = useState(false);
  const [menuPurchasesOpen, setMenuPurchasesOpen] = useState(false);
  const [menuAccountOpen, setMenuAccountOpen] = useState(false);
  const [menuB2Bopen, setMenuB2BOpen] = useState(false);

  const { t } = useTranslation();
  const mail = authorization.userProfile()?.email;
  let avatarUrl;
  if (mail !== undefined && mail !== null) {
    const hashHex = MD5(mail).toString();
    avatarUrl = `https://www.gravatar.com/avatar/${hashHex}?d=robohash`;
  }

  const MENUS: NavItem[] = [
    {
      ...routeHome,
      text: 'HOME',
      icon: House
    },
    {
      ...routeAnalitics,
      text: 'Analitics',
      icon: BarChart
    },
    {
      path: '#',
      text: 'PURCHASES',
      forRealm: true,
      icon: Cart,
      className: `has-treeview ${menuPurchasesOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuPurchasesOpen(!menuPurchasesOpen),
      roles: [],
      children: [
        {
          ...routePurchases,
          text: 'PURCHASES_LIST',
          icon: List
        },
        {
          ...routeAddPurchase,
          text: 'ADD_PURCHASE',
          icon: CartPlusFill
        },
        {
          ...transactions,
          text: 'TRANSACTIONS_LIST',
          icon: ArrowLeftRight
        },
        {
          ...routeGenerationBillingCodes,
          text: 'CODES_GENERATOR',
          icon: GearWideConnected
        }
      ]
    },
    {
      path: '#',
      text: 'B2B',
      forRealm: true,
      icon: BagCheck,
      className: `has-treeview ${menuB2Bopen ? 'menu-open' : ''}`,
      onClick: () => setMenuB2BOpen(!menuB2Bopen),
      roles: [],
      children: [
        {
          ...routeB2B,
          text: 'CHECK_NFT',
          icon: Check2Circle
        }
      ]
    },
    {
      path: '#',
      text: 'CONTACTS',
      icon: PersonFill,
      forRealm: true,
      roles: [],
      className: `has-treeview ${menuContactOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuContactOpen(!menuContactOpen),
      children: [
        {
          ...routeContacts,
          text: 'CONTACTS_LIST',
          icon: PersonLinesFill
        },
        {
          ...routeAddContact,
          text: 'ADD_CONTACT',
          icon: PersonPlusFill
        }
      ]
    },
    {
      path: '#',
      text: 'WALLETS',
      icon: WalletFill,
      forRealm: true,
      roles: [],
      className: `has-treeview ${menuWalletsOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuWalletsOpen(!menuWalletsOpen),
      children: [
        {
          ...routeWalletsList,
          text: 'CONTACTS_WALLETS_LIST',
          icon: Wallet2
        }
      ]
    },
    {
      path: '#',
      text: 'SENSORS',
      icon: Phone,
      forRealm: true,
      roles: [],
      className: `has-treeview ${menuSensorsOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuSensorsOpen(!menuSensorsOpen),
      children: [
        {
          ...awairRefundVoucherList,
          text: 'AWAIR_LIST',
          icon: Collection
        },
        {
          ...routeOwners,
          text: 'SENSORS_OWNERS',
          icon: FilePerson
        },
        {
          ...routeSensors,
          text: 'LIVE_SENSORS',
          icon: PhoneVibrate
        },
        {
          ...routeAirquino,
          path: '/sensors/airqino/testing',
          text: 'AIRQINO_TESTING',
          icon: Cpu
        },
        {
          ...routeSensorsTesting,
          path: '/sensors/turtle/testing',
          text: 'TURTLE_TESTING',
          icon: Cpu
        },
        {
          ...routeTempSensors,
          text: 'TEMPORARY_SENSORS',
          icon: PhoneLandscape
        },
        {
          ...routeAddSensor,
          text: 'ADD_SENSORS',
          icon: FilePlus
        }
      ]
    },
    {
      path: '#',
      text: 'Licenses',
      icon: Unlock,
      forRealm: true,
      roles: [],
      className: `has-treeview ${menuLicenseOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuLicenseOpen(!menuLicenseOpen),
      children: [
        {
          ...routeLicenses,
          text: 'Live Licenses',
          icon: UnlockFill
        },
        {
          ...routeLicensesHistory,
          text: 'Licenses History',
          icon: ClockHistory
        }
      ]
    },
    {
      path: '#',
      text: 'Support',
      icon: People,
      forRealm: true,
      roles: [],
      className: `has-treeview ${menuAccountOpen ? 'menu-open' : ''}`,
      onClick: () => setMenuAccountOpen(!menuAccountOpen),
      children: [
        {
          ...routeChangeAccount,
          text: 'Change Account',
          icon: PeopleFill
        },
        {
          ...routeNftMove,
          text: 'Nft Move',
          icon: ArrowsMove
        },
        {
          ...routeClawback,
          text: 'Clawback',
          icon: ArrowsMove
        },
        {
          ...routeMergeAccount,
          text: 'Merge Account',
          icon: PersonPlusFill
        }
      ]
    }
  ];

  return (
    <aside className='main-sidebar sidebar-dark-primary elevation-4 sidebar-no-expand' >
      {/* < !--Brand Logo-- > */}
      <a href='/' className='brand-link'>
        <img src='favicon.svg' alt='Logo' className='brand-image img-circle elevation-3' />
        <span className='brand-text font-weight-light'>{t('BRAND_NAME')}</span>
      </a>

      {/* <!-- Sidebar --> */}
      <div className='sidebar'>
        {/* <!-- Sidebar user panel (optional) --> */}
        <div className='user-panel mt-3 pb-3 mb-3 d-flex'>
          <div className='image'>
            <img src={avatarUrl} className='img-circle elevation-2' alt='avatar' />
          </div>
          <div className='info text-light'>
            {props.username}
          </div>
        </div>

        {/* <!-- Sidebar Menu --> */}
        <nav className='mt-2'>
          <ul className='nav nav-pills nav-sidebar flex-column nav-child-indent' data-widget='treeview' role='menu'>

            {
              MENUS.map((item) => <Fragment key={item.text}>
                {
                  authorization.isAuthorized(item.roles, item.forRealm) &&
                  (!item.children || (item.children.length && !menuIsEmpty(item))) &&
                  <Nav.Item className={item.className} key={item.text}>
                    <Link to={item.path} className='nav-link' onClick={item.onClick}>
                      <item.icon className='nav-icon' />
                      <p> {t(item.text)}
                        {
                          item.children && item.children.length &&
                          <ChevronDown className='right' />
                        }
                      </p>
                    </Link>
                    {
                      item.children &&
                      <ul className='nav nav-treeview'>
                        {
                          item.children.map((subitem) => <>
                            {
                              authorization.isAuthorized(
                                subitem.roles,
                                subitem.forRealm
                              ) &&
                              <Nav.Item className={subitem.className} onClick={subitem.onClick} key={subitem.text}>
                                <Link to={subitem.path} className='nav-link'>
                                  <subitem.icon className='nav-icon' />
                                  <p> {t(subitem.text)}</p>
                                </Link>
                              </Nav.Item>
                            }
                          </>)
                        }
                      </ul>
                    }
                  </Nav.Item>
                }
              </Fragment>)
            }
          </ul>
        </nav>

        {/* <!-- /.sidebar-menu --> */}
      </div>
      {/* <!-- /.sidebar --> */}
    </aside >
  );
};

const PwSidebar = withRouter(PwSidebarNoRouter);
export default PwSidebar;